module.exports = __webpack_public_path__ + "static/akniga-7b7d73f111d9a7be5801f79cc0bc4c44.png";